// extracted by mini-css-extract-plugin
module.exports = {"hat":"Logo_hat__z7Lnb","christmas":"Logo_christmas__3wLyf","useFade-fadeIn":"Logo_useFade-fadeIn__muT9V","useFade-fadeOut":"Logo_useFade-fadeOut__I4DON"};